export const config_rect = {
  width: 300,
  height: 300,
  max_count: 6
}

export const config_map = {
  options: {
    zoomControl: false,
    maxZoom: 18,
    minZoom: 11,
    preferCanvas: true,
    zoomSnap: 0.1, // 0.5,
    wheelPxPerZoomLevel: 300
  },
  url: 'https://api.mapbox.com/styles/v1/mapbox/light-v10/tiles/256/{z}/{x}/{y}?access_token=pk.eyJ1IjoiZnp2ZHhtcmRmOTYiLCJhIjoiY2xmcXhtN3A0MDJ6dzN0bnQ4MWJtbXQ0ZiJ9.6T1RmZE0MQAcJzYxmdJ3SQ',
  attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
}

export const config_routes = {
  max_count_in_map: 3
}